<template>
  <ModelManagerPage
          lower-app-name="emarket"
          lower-model-name="categoryl1"
          version="1"
          obj-label="商品一级分类">
  </ModelManagerPage>
</template>

<script>
import ModelManagerPage from './ModelManagerPage.vue'

export default {
  name: 'CategoryL1Manager',
  props: {
  },
  components: {
    ModelManagerPage
  },
  data: function () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// CategoryL1Manager.vue?313299fa